module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-03.03e48965.jpg";